import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL, getStoredAuthToken } from './api';

export const BECAISSE_AUDIENCE_VIEWS = {
  '/caisse': 'caisse',
  '/caisse/reservations': 'reservations',
  '/pad': 'pad',
};

export function BecaisseAudienceVisit() {
  const location = useLocation();
  const lastNavigation = useRef(null);
  useEffect(() => {
    const view = BECAISSE_AUDIENCE_VIEWS[location.pathname];
    const navigation = `${location.key}:${location.pathname}`;
    if (!view || lastNavigation.current === navigation
        || window.location.origin !== 'https://beborne.com'
        || navigator.webdriver || navigator.doNotTrack === '1'
        || navigator.globalPrivacyControl || !window.crypto?.randomUUID) return;
    const token = getStoredAuthToken();
    if (!token) return;
    lastNavigation.current = navigation;
    void fetch(`${API_URL}/api/audience/becaisse/visit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', keepalive: true,
      body: JSON.stringify({ view, eventId: window.crypto.randomUUID() }),
    }).catch(() => {});
  }, [location.key, location.pathname]);
  return null;
}
